var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.989,
    viewBox: "0 0 20 19.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-Jun-19-17-27-04",
    transform: "translate(-21.799 329.904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.793-329.815a9.042,9.042,0,0,0-1.955.519,10.117,10.117,0,0,0-5.651,5.309c-.285.652-.2,1.082.272,1.348a.724.724,0,0,0,.823,0c.2-.114.3-.253.626-.9A8.305,8.305,0,0,1,40.8-328.05a10.662,10.662,0,0,1,2.911-.032,8.3,8.3,0,0,1,6.473,5.606,6.8,6.8,0,0,1,.38,2.531,7.578,7.578,0,0,1-.854,3.733,7.2,7.2,0,0,1-1.531,2.094,7.722,7.722,0,0,1-2.17,1.6,8.344,8.344,0,0,1-6.5.361,8.415,8.415,0,0,1-4.7-4.341,1.713,1.713,0,0,0-.424-.658.907.907,0,0,0-1.234.228c-.209.342-.165.645.19,1.379a10.012,10.012,0,0,0,11.485,5.315,10.045,10.045,0,0,0,7.315-7.669,12.058,12.058,0,0,0,.07-3.638,10.033,10.033,0,0,0-2.968-5.594A9.719,9.719,0,0,0,42.3-329.9,14.511,14.511,0,0,0,40.793-329.815Z",
    transform: "translate(-10.508)",
    fill: "#939a9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.209-233.829a.894.894,0,0,0-.329,1.095,10.61,10.61,0,0,0,.9.974l.835.842H28.045c-5.315,0-5.581.006-5.79.12a.861.861,0,0,0,.063,1.55c.228.089.861.1,5.777.1h5.518l-.88.88-.88.88-.025.342a.751.751,0,0,0,.443.829.828.828,0,0,0,.721.038,45.452,45.452,0,0,0,3.442-3.392.961.961,0,0,0,.038-.88c-.114-.215-3.233-3.335-3.442-3.436A.968.968,0,0,0,32.209-233.829Z",
    transform: "translate(0 -89.88)",
    fill: "#939a9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/log__out__icon.3c5600e37f9d4fcaeefdd0a3ca6733ca.svg";
export { ForwardRef as ReactComponent };